import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'aa-input-upload',
    templateUrl: './input-upload.component.html',
    styleUrls: [],
    standalone: false
})
export class InputUploadComponent implements OnInit
{
    public invalid: boolean = true;
    constructor() { }

    ngOnInit ()
    {
    }
    onUploadError ($event)
    {
    }

    onUploadSuccess ($event)
    {
    }
}
